<template>
  <div class="brief-feedback">
    <template v-if="!sent">
      <div class="d-flex align-center flex-wrap" style="gap: 4px">
        <v-btn
          small
          text
          color="grey darken-1"
          class="mb-4"
          @click="open = !open"
        >
          <v-icon left small>mdi-flag-outline</v-icon>
          Signaler un problème
        </v-btn>

        <v-btn
          v-if="sessionId && isStaff"
          small
          text
          color="grey darken-1"
          class="mb-4"
          :to="{ name: 'admin_agent_session_detail', params: { id: sessionId } }"
        >
          <v-icon left small>mdi-text-search</v-icon>
          Voir la session
        </v-btn>
      </div>

      <v-expand-transition>
        <div v-if="open" class="feedback-panel mt-2 pa-3">
          <div class="text-caption text-uppercase grey--text font-weight-medium mb-2">
            Qualité du brief généré
          </div>
          <v-rating
            :value="rating || 0"
            :length="5"
            color="amber darken-1"
            background-color="grey lighten-1"
            dense
            @input="v => { rating = v || null }"
          />
          <div class="text-caption grey--text mb-2">
            {{ ratingLabel }}
          </div>
          <v-textarea
            v-model="text"
            label="Qu'est-ce qui ne va pas ?"
            rows="3"
            auto-grow
            outlined
            dense
            hide-details
            class="mb-3"
          />
          <v-checkbox
            v-if="supportEnabled"
            v-model="openTicket"
            label="Ouvrir un ticket"
            dense
            hide-details
            class="mt-0 mb-3"
          />
          <v-btn
            color="primary"
            elevation="0"
            small
            :disabled="!rating || sending"
            :loading="sending"
            @click="submit"
          >
            Envoyer
          </v-btn>
          <v-btn text small class="ml-2" @click="open = false">
            Annuler
          </v-btn>
        </div>
      </v-expand-transition>
    </template>

    <v-alert v-else type="success" dense text class="mt-4">
      Merci pour votre retour.
      <router-link v-if="ticketId" :to="{ name: 'ticket_detail', params: { id: ticketId } }">
        Voir le ticket
      </router-link>
    </v-alert>
  </div>
</template>

<script>
import { submitBriefFeedback } from '@/services/projectApi'
import features from '@/config/features'

const LABELS = ['', 'Très mauvais', 'Mauvais', 'Moyen', 'Bon', 'Parfait']

export default {
  name: 'BriefFeedbackPanel',
  props: {
    projectId: { type: [String, Number], required: true },
    sessionId: { type: String, default: null },
  },
  data() {
    return {
      open: false,
      rating: null,
      openTicket: false,
      supportEnabled: features.support,
      ticketId: null,
      text: '',
      sending: false,
      sent: false,
    }
  },
  computed: {
    isStaff() {
      return this.$store.getters['settings/isStaff']
    },
    ratingLabel() {
      return this.rating ? LABELS[this.rating] : 'Sélectionnez une note'
    },
  },
  methods: {
    async submit() {
      this.sending = true
      try {
        const res = await submitBriefFeedback(this.projectId, this.rating, this.text, this.openTicket)
        this.ticketId = (res && res.ticket_id) || null
        this.sent = true
      } catch (e) {
        // TODO: snackbar on error
      } finally {
        this.sending = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.feedback-panel {
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 6px;
  max-width: 480px;
}
</style>
